/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import toNumber from 'lodash/toNumber';
import reduce from 'lodash/reduce';
import lodashMap from 'lodash/map';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import uniq from 'lodash/uniq';
import pick from 'lodash/pick';
import {
    ITINERARY_SINGLE_TYPE_FACILITY,
    STANDARD_TYPE_FACILITY,
} from '../constants/campground';
import { isDateValid } from './dateUtils';

/* ========================== */
/*      ITINERARY SINGLE      */
/* ========================== */

export const updateNightMapWithDelayCheckInDate = (nightMap, date) => {
    const nightMapKeys = Object.keys(nightMap);

    // nightMap may not be in order, so we sort it
    nightMapKeys.sort((a, b) => {
        return new Date(a) - new Date(b);
    });

    const newNights = nightMapKeys.filter((currDate) => currDate >= date);
    return pick(nightMap, newNights);
};

export const cleanSupplementalSelections = (supplementalSelection) => {
    return pickBy(supplementalSelection, (suppSelection) => {
        const filteredSelections = suppSelection.filter(
            (sel) => isDateValid(sel.start_date) && isDateValid(sel.end_date)
        );
        return !isEmpty(filteredSelections);
    });
};

export const getUniqueSiteIds = (nightMap) => {
    const campsitesIds = uniq(lodashMap(nightMap, (night) => night.campsite_id));
    return campsitesIds;
};

export const isMultiSiteReservation = (nightMap) => {
    if (!nightMap) return false;
    const campsitesIds = getUniqueSiteIds(nightMap);
    return campsitesIds.length > 1;
};

export const formatMultiSiteName = (nightMap) => {
    if (!nightMap) return '';

    const nightMapKeys = Object.keys(nightMap);

    // nightMap may not be in order, so we sort it
    nightMapKeys.sort((a, b) => {
        return new Date(a) - new Date(b);
    });

    const siteNames = uniq(
        lodashMap(nightMapKeys, (nightKey) => nightMap[nightKey].campsite_name)
    );
    return siteNames.join(', ');
};

export const updateNightMapOccupants = (reservation) => {
    const groupSize = get(
        reservation,
        'site_occupant.custom_order_details.group_size',
        null
    );
    const nightMap = get(reservation, 'night_map', {});
    const hasMultipleSites = isMultiSiteReservation(nightMap);
    const isItinerarySingle =
        get(reservation, 'facility_type', STANDARD_TYPE_FACILITY) ===
        ITINERARY_SINGLE_TYPE_FACILITY;

    const mainGroupSize = groupSize.group_size;
    const groupSizeSame = groupSize.is_group_size_same === 'true';

    let newNightMap = reduce(
        nightMap,
        (acc, curr, key) => {
            acc[key] = {
                ...curr,
                num_people: toNumber(
                    (isItinerarySingle || hasMultipleSites) && !groupSizeSame
                        ? get(groupSize, `group_size-${curr.campsite_id}`)
                        : mainGroupSize
                ),
            };
            return acc;
        },
        {}
    );

    if (isEmpty(newNightMap) && reservation.start_date === reservation.end_date) {
        newNightMap = {
            [reservation.start_date]: {
                campsite_id: reservation.campsite_id,
            },
        };
    }

    return newNightMap;
};
